export { default as LifestylesIndexPageCategoriesNavBody } from './LifestylesIndexPageCategoriesNavBody';
